import { useSelector } from 'react-redux'

import { faCopy } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { onInfo } from '../../../../utils/apiHelper'
import ClickableIcon from '../../../antd/Buttons/ClickableIcon'
import EntityOptionDisplayer from '../EntityOptionDisplayer'

const SchoolOptionDisplayer = ({ entity }) => {
  const t = useSelector(selectTranslate)

  const acronym = entity.acronym ?? entity.abbreviation ?? ''

  const handleCopy = e => {
    e.stopPropagation()
    navigator.clipboard.writeText(`${acronym} - ${entity.name ?? ''} - ${entity.address ?? ''}`)
    onInfo(t('common.value_copied'))
  }

  return (
    <div className='school-option-displayer flex-row ai-ctr w-100'>
      <EntityOptionDisplayer entity={entity} />
      <div className='school-option-copy' onMouseDown={e => e.stopPropagation()} onClick={handleCopy}>
        <ClickableIcon
          icon={faCopy}
          size='small'
          title={t('school_option_displayer.copy_into_clipboard', { acronym, name: entity.name, address: entity.address })}
        />
      </div>
    </div>
  )
}

export default SchoolOptionDisplayer
